let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6CaxX")).then(() => parcelRequire('77M8h'));